<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="修改约课学员消课价格" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>修改约课学员消课价格</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-card-text class="mt-4">
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="原价格" v-model="add.originPrice" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="新单价" v-model="add.newPrice" type="number" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitUpdate" :loading="add.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	export default {
		name:"update-record-book-student-price",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			bookStudent:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.add.newPrice = "";
					this.add.originPrice = this.bookStudent.recordPrice;
				}
			}
		},
		data(){
			return {
				add: {
					submitting:false,
					originPrice:"",
					newPrice:""
				},
				hideShow:this.show
			}
		},
		mounted() {
			console.log("update record book student price mounted");
		},
		methods:{
			submitUpdate(){
				console.log("提交修改");
				
				// 提交修改价格
				if (!this.add.newPrice) {
					that.$noty.error("请输入新的课时价格");
					return
				}
				this.add.submitting = true;
							
				// api
				const that = this;
				let url = `/edu/record/book/student/price/update`;
				let postData = {
					bookId:this.bookStudent.id,
					newPrice:this.add.newPrice
				};
							
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.add.submitting = false;
							
							// 触发调用者success事件
							that.$emit("success",that.add.newPrice);
							
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
				
				
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>

